import React, { useRef } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';

import { TypeMaster } from 'models/type/TypeMaster';

import {
    WorkflowTypeMasterForm,
    WorkflowTypeMasterFormRefHandle
} from './WorkflowTypeMasterForm';

export type WorkflowTypeMasterFormModalProps = {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    disabledKeyField?: boolean;
    defaultValues?: TypeMaster;
    onSubmit?: (formValues: TypeMaster) => void;
};

export const WorkflowTypeMasterFormModal = (
    props: WorkflowTypeMasterFormModalProps
) => {
    const {
        disabledKeyField,
        title,
        isOpen,
        onClose,
        defaultValues,
        onSubmit
    } = props;

    const formRef = useRef<WorkflowTypeMasterFormRefHandle>(null);

    const handleSaveClick = () => {
        const formValues = formRef.current?.submit();
        if (!formValues) {
            return;
        }

        onSubmit?.(formValues);
    };

    return (
        <Modal
            size="xl"
            isOpen={isOpen}
            toggle={onClose}
        >
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>
                <WorkflowTypeMasterForm
                    ref={formRef}
                    disabledKeyField={disabledKeyField}
                    defaultValues={defaultValues}
                />
            </ModalBody>
            <ModalFooter className="flex justify-end">
                <Button
                    color="primary"
                    onClick={handleSaveClick}
                >
                    Save
                </Button>
                <Button
                    color="secondary"
                    onClick={onClose}
                    className="border-none bg-neutral-600"
                >
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};
